import { Link } from "react-router-dom";
import { Camera, ExternalLink } from "lucide-react";
import PageMeta from "./PageMeta";

const webcams = [
  {
    location: "Porthleven",
    label: "Harbour & Beach",
    id: "1658683755",
  },
  {
    location: "St Ives",
    label: "Clodgy Point",
    id: "1793900634",
  },
  {
    location: "St Ives Island",
    label: "St Ives",
    id: "1793900624",
  },
  {
    location: "Newquay",
    label: "Headland",
    id: "1697066186",
  },
  {
    location: "Padstow",
    label: "Harbour",
    id: "1603997680",
  },
  {
    location: "Polzeath",
    label: "Webcam",
    id: "1793906577",
  },
  {
    location: "Padstow",
    label: "Webcam",
    id: "1684845118",
  },
  {
    location: "Padstow & Polzeath Beach",
    label: "Scenic Shoreline",
    id: "1793900639",
  },
  {
    location: "Marazion",
    label: "Harbour & Mount's Bay",
    id: "1684488413",
  },
  {
    location: "Penzance",
    label: "Harbour",
    id: "1683031700",
  },
  {
    location: "Gwithian",
    label: "Hayle & Gwithian Beach",
    id: "1793900619",
  },
  {
    location: "Falmouth",
    label: "Sea Front",
    id: "1677265625",
  },
  {
    location: "Sennen Cove",
    label: "Sennen Beach, Gwynver Beach & Cape Cornwall",
    id: "1562597622",
  },
];

export default function SeaViewsPage() {
  return (
    <>
      <PageMeta
        title="Sea Views — Live Webcams | Redruth Sea Angling Association"
        description="Live webcam feeds from around the Cornish coast — check sea conditions, coastal weather, and fishing visibility before you head out."
        keywords="live sea webcams, sea webcams Cornwall, coastal weather, live sea conditions, Redruth Sea Angling Association, sea views, fishing webcams, Cornish coast webcams, coastal safety"
        url="https://www.redruthseaanglingassociation.co.uk/sea-views"
        image="https://www.redruthseaanglingassociation.co.uk/assets/scenic_background.png"
      />
      <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <div className="mx-auto max-w-3xl px-6 py-16 sm:px-8 lg:px-12">

        <Link
          to="/"
          className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20"
        >
          ← Back
        </Link>

        <div className="mt-8 flex items-start gap-4">
          <div className="shrink-0 rounded-xl border border-cyan-400/20 bg-cyan-500/10 p-3">
            <Camera className="h-6 w-6 text-cyan-400" />
          </div>
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Redruth Sea Angling Association</p>
            <h1 className="heading-glow mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">Sea Views</h1>
            <p className="mt-4 text-base leading-7 text-slate-400">
              Live webcam feeds from around the Cornish coast — check conditions before you head out.
              Feeds are provided by <a href="https://www.windy.com" target="_blank" rel="noopener noreferrer" className="text-cyan-400 hover:text-cyan-300 underline">Windy.com</a>.
            </p>
          </div>
        </div>

        <div className="mt-10 rounded-2xl border border-white/10 bg-white/5 divide-y divide-white/10">
          {webcams.map((cam) => (
            <div key={cam.id} className="flex items-center justify-between gap-4 px-6 py-4">
              <div>
                <p className="text-sm font-bold text-white">{cam.location}</p>
                <p className="text-xs text-cyan-300 mt-0.5">{cam.label}</p>
              </div>
              <a
                href={`https://www.windy.com/webcams/${cam.id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="shrink-0 inline-flex items-center gap-1.5 rounded-lg border border-cyan-300/30 bg-cyan-400/10 px-3 py-1.5 text-xs font-semibold text-cyan-200 transition hover:bg-cyan-400/20"
              >
                View Live <ExternalLink className="h-3 w-3" />
              </a>
            </div>
          ))}
        </div>

      </div>
    </div>
    </>
  );
}
